// Angular modules
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

// Import directive
import { ModalDirective } from './modal.directive';

// Import component
import { ModalComponent } from './component/modal.component';

// Import service
import { ModalService } from './modal.service';

@NgModule({
    declarations: [ModalDirective, ModalComponent],
    imports: [
        CommonModule
    ],
    exports: [
        ModalComponent,
    ]
})
export class ModalModule {
    public static forRoot(): ModuleWithProviders<ModalModule> {
        return {
            ngModule: ModalModule,
            providers: [ModalService]
        }
    }

    constructor() {
        console.log('ModalModule initialized');
    }
}
